module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kca.a4d474631f0e00244a83deaea34c1bca.png";